
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetobusonrent() {



    const cardData =
    {
        keyword: ' Pune to Bus On Rent',
        heading: 'Amruta Travels:  Pune to Bus On Rent',
        headingDescription: 'Amruta Travels offers Pune to Bus On Rent services, delivering dependable and comfortable transportation for all your outstation travel needs. Whether you are planning a family trip, corporate outing, religious tour, or group adventure, our buses are ready to serve with top-notch comfort and safety. Choose from a range of well-maintained vehicles including 17-seater, 32-seater, and 50-seater buses, all driven by experienced and courteous drivers. With competitive pricing, timely service, and 24/7 availability, Amruta Travels ensures your journey from Pune is smooth, secure, and hassle-free. Book your Pune to outstation bus with us today!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



 "services": [
    {
      "name": "Pune to Goa Mini Bus on Rent",
      "description": "Amruta Travels offers mini buses on rent from Pune to Goa, perfect for family trips, group vacations, and college tours. Enjoy a scenic coastal drive with AC and Non-AC options, push-back seating, and professional drivers ensuring a smooth ride."
    },
    {
      "name": "Pune to Goa Tempo Traveller on Rent",
      "description": "Travel from Pune to Goa with comfort and convenience in our Tempo Travellers. Ideal for groups of 9 to 20 people, our vehicles include AC, spacious interiors, and experienced drivers—suitable for weekend getaways, events, or family holidays."
    },
    {
      "name": "Pune to Goa Urbania on Rent",
      "description": "Amruta Travels provides Force Urbania vans for rent from Pune to Goa, offering premium seating, air conditioning, and a smooth ride. Ideal for luxury family trips, corporate tours, or VIP transport to the beach capital of India."
    },
    {
      "name": "Pune to Goa 17 Seater on Rent",
      "description": "For mid-sized groups, our 17-seater buses are a great fit for Pune to Goa travel. Featuring AC comfort, ample legroom, and reclining seats, they are a reliable choice for holidaymakers and business travelers alike."
    },
    {
      "name": "Pune to Goa 14 17 25 32 Seater on Rent",
      "description": "Choose from a range of seater options—14, 17, 25, and 32—for your Pune to Goa trip. Amruta Travels offers vehicles with modern amenities, ideal for families, student groups, or corporate retreats to Goa."
    },
    {
      "name": "Pune to Goa 35 45 50 Seater on Rent",
      "description": "For large groups, Amruta Travels offers 35 to 50-seater buses from Pune to Goa. These AC buses feature spacious interiors, luggage compartments, and entertainment systems, perfect for weddings, large corporate tours, and group vacations."
    },
    {
      "name": "Pune to Goa Bus Package on Rent",
      "description": "Book a complete bus package from Pune to Goa that includes vehicle rental, driver, and flexible travel schedules. Perfect for family holidays, school trips, or company offsites, ensuring a hassle-free and affordable travel experience."
    },
    {
      "name": "Hire Pune to Goa Mini Bus & Tempo Traveller on Rent",
      "description": "Amruta Travels provides well-maintained mini buses and Tempo Travellers from Pune to Goa, available in multiple seating capacities. Ideal for small to mid-sized groups looking for a reliable and enjoyable road trip."
    },
    {
      "name": "Pune to Goa AC Bus on Rent",
      "description": "Enjoy cool and relaxed travel with our AC bus rentals from Pune to Goa. Suitable for long-distance comfort, these buses offer push-back seats, music systems, and professional service, ensuring a delightful coastal journey."
    },
    {
      "name": "Hire a Bus from Pune to Goa",
      "description": "Whether it's a family vacation, wedding function, or corporate tour, Amruta Travels provides buses in various sizes for hire from Pune to Goa. Choose from AC/Non-AC options and travel comfortably with trained drivers."
    },
    {
      "name": "Pune to Goa Family Trip Bus Hire",
      "description": "Plan your family getaway to Goa with our dedicated family-trip bus rentals. Amruta Travels ensures safe, clean, and spacious travel, ideal for all age groups and tailored to your schedule and preferences."
    },
    {
      "name": "Pune to Goa Corporate Bus Hire",
      "description": "Our corporate bus rentals from Pune to Goa are perfect for team outings, offsite meetings, and conferences. With punctual service, AC comfort, and spacious seating, your team will travel with ease and professionalism."
    },
    {
      "name": "Pune to Goa Weekend Getaway Bus Rental",
      "description": "Book a weekend escape to Goa with Amruta Travels. We offer quick turnaround rentals with flexible return options, ideal for couples, friends, or teams wanting a short but refreshing trip to Goa."
    },
    {
      "name": "Comfortable Bus from Pune to Goa",
      "description": "Amruta Travels ensures a smooth and restful journey from Pune to Goa with its fleet of comfortable buses. Whether you're traveling for fun or function, enjoy ample space, reclining seats, and a peaceful ride."
    },
    {
      "name": "32 Seater Bus Rental Pune to Goa",
      "description": "Our 32-seater buses offer the perfect blend of comfort and capacity for Pune to Goa trips. Spacious, air-conditioned, and equipped with luggage compartments—perfect for groups heading to Goa for leisure or events."
    },
    {
      "name": "50 Seater Bus Hire from Pune to Goa",
      "description": "Hire a 50-seater AC bus for your Goa journey from Pune. Ideal for schools, weddings, or group tourism, Amruta Travels ensures smooth travel, professional drivers, and reliable service throughout the journey."
    }
  ],
  "tableData": [
    ["Pune to Goa Mini Bus on Rent", "Pune to Goa Tempo Traveller on Rent"],
    ["Pune to Goa Urbania on Rent", "Pune to Goa 17 Seater on Rent"],
    ["Pune to Goa 14 17 25 32 Seater on Rent", "Pune to Goa 35 45 50 Seater on Rent"],
    ["Pune to Goa Bus Package on Rent", "Hire Pune to Goa Mini Bus & Tempo Traveller on Rent"],
    ["Pune to Goa AC Bus on Rent", "Hire a Bus from Pune to Goa"],
    ["Pune to Goa Family Trip Bus Hire", "Pune to Goa Corporate Bus Hire"],
    ["Pune to Goa Weekend Getaway Bus Rental", "Comfortable Bus from Pune to Goa"],
    ["32 Seater Bus Rental Pune to Goa", "50 Seater Bus Hire from Pune to Goa"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Travel from Pune",
    "WhyChoosedescription": "Amruta Travels offers Pune to Bus on Rent services, providing a comfortable and reliable transportation solution for your group. Whether you're planning a family outing, corporate event, or a pilgrimage, our buses are equipped with spacious seating, air conditioning, and modern amenities to ensure a smooth and enjoyable journey. We guarantee a hassle-free and pleasant travel experience from Pune to your desired destination, ensuring everyone’s comfort and satisfaction."
  },
  {
    "WhyChooseheading": "Ideal for Group Outings, Corporate Events, and Pilgrimages",
    "WhyChoosedescription": "Our bus rental services are perfect for group outings, corporate events, and pilgrimages from Pune. Whether you are planning a day trip to nearby attractions or a longer journey to religious or cultural sites, we provide dependable transportation that ensures your group travels together in comfort. With ample seating, luggage space, and a variety of options to choose from, our buses are ideal for any kind of group travel."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for a Safe Journey",
    "WhyChoosedescription": "Safety is our top priority. Our experienced and professional drivers are familiar with routes from Pune to various destinations and are trained to ensure a safe and comfortable journey for all passengers. They prioritize punctuality, follow safety guidelines, and maintain courteous behavior throughout the trip. You can trust our drivers to ensure your journey is smooth, timely, and free of any concerns."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "At Amruta Travels, we offer affordable and competitive pricing for Pune to Bus on Rent. Our pricing is transparent with no hidden costs, ensuring that you can plan your trip without any surprises. Whether you're looking for a short local trip or a long-distance journey, we offer budget-friendly options without compromising on comfort, safety, or service."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses for a Comfortable Ride",
    "WhyChoosedescription": "We take great pride in maintaining our fleet of buses to the highest standards. Each bus is regularly serviced, cleaned, and inspected for safety and performance. From the moment you step on board, you’ll find clean and comfortable seating, with air conditioning and well-kept interiors that ensure a relaxing journey. Whether it's a short ride within Pune or a longer journey, we ensure your comfort throughout the trip."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations Across Pune",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations across Pune to make your trip as convenient as possible. Whether you're located at your office, home, or a specific venue, we can accommodate your preferred pickup points. We also provide timely drop-off services at your destination, ensuring that your journey is seamless and stress-free."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Any Type of Group Trip",
    "WhyChoosedescription": "Every trip is unique, and we offer fully customizable itineraries to suit your group’s specific needs. Whether you’re planning multiple stops, need to extend travel time, or have special requests for your journey, we work with you to tailor the perfect travel plan. Our goal is to provide flexibility and ensure that your trip from Pune is perfectly organized."
  },
  {
    "WhyChooseheading": "Easy Booking with Full Customer Support",
    "WhyChoosedescription": "Booking your Pune to Bus on Rent with Amruta Travels is simple and hassle-free. You can easily book your bus online, call our customer support team for assistance, or visit our office. Our dedicated customer support staff is available to help you with any queries, assist with booking details, and ensure that everything is in place for a smooth and pleasant journey."
  }
]



























    }

const faqData = [
  {
    question: 'How can I rent a bus for a trip from Pune?',
    answer: 'Renting a bus for your trip from Pune with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll help you choose the right bus based on your travel needs, group size, and preferences.',
  },
  {
    question: 'What types of buses are available for rent in Pune?',
    answer: 'We offer a variety of buses for rent in Pune, including 32, 35, 45, and 50-seater options. Whether you need a standard, luxury, or AC bus, we have a vehicle to meet your travel requirements.',
  },
  {
    question: 'Are the buses comfortable for long-distance trips from Pune?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors. We ensure that your journey is smooth and enjoyable, whether for local or long-distance travel.',
  },
  {
    question: 'How much does it cost to rent a bus from Pune?',
    answer: 'The cost of renting a bus from Pune depends on factors such as bus size, trip duration, and distance. Please contact us for a personalized quote based on your trip details.',
  },
  {
    question: 'Can I rent a bus for a one-day trip from Pune?',
    answer: 'Yes, we offer flexible rental options for one-day trips from Pune. Whether you’re planning a city tour, pilgrimage, or corporate event, we’ll tailor the rental service to meet your needs.',
  },
  {
    question: 'Do you provide both standard and luxury buses for rent from Pune?',
    answer: 'Yes, we provide both standard and luxury buses. Our luxury buses offer additional amenities such as premium seating, air conditioning, and entertainment options, ensuring a more luxurious travel experience.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. Just share your preferred locations with us, and we’ll plan the best route for your convenience.',
  },
  {
    question: 'Why should I choose Amruta Travels for bus rental from Pune?',
    answer: 'Amruta Travels is known for offering reliable, safe, and comfortable bus rental services from Pune. We prioritize customer satisfaction, provide well-maintained buses, and ensure that your trip is smooth, safe, and enjoyable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ravi Shinde',
    role: 'Event Coordinator, Pune',
    text: 'We rented a 50-seater bus from Amruta Travels for a corporate event. The bus was spacious, well-maintained, and the driver was very professional. We had a great experience and will definitely choose them for our future trips.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    role: 'Family Trip Organizer, Pune',
    text: 'I booked a 35-seater bus for a family trip. The service was amazing, the bus was very comfortable, and the driver made the journey smooth and safe. I will definitely use Amruta Travels for any future travel needs.',
    rating: 5,
  },
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Bus on Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-goa-bus-on-rent.jpg",
  "description": "Hire a wide range of buses from Pune to Goa, including Mini Bus, Tempo Traveller, Urbania, and AC Coaches. Options available: 14, 17, 25, 32, 35, 45, and 50 seater buses for family trips, corporate travel, weekend getaways, and group tours. Book affordable and comfortable Pune to Goa bus rental with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6290"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5499",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-goa-bus-on-rent"
  }
};






    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Pune to Goa Bus on Rent | AC Bus, Tempo Traveller, Urbania | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book Pune to Goa bus rental services including AC Mini Bus, Tempo Traveller, Urbania, and coaches. 14 to 50 seater options available for holidays, group travel, and weekend trips. Travel with comfort from Pune to Goa with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobusonrent;